<template>
  <underfloor-heating :color="getColor" class="w-100" />
</template>

<script>
import HeatDeviceWrapper from '@/components/services/service/icon-wrappers/HeatDeviceWrapper.vue';

export default {
  name: 'UnderfloorHeatingWrapper',
  extends: HeatDeviceWrapper,
};
</script>
